// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Hydroelectric .Hydroelectric-table {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.Hydroelectric .Hydroelectric-table .cell {\n    text-align: center;\n}\n.Hydroelectric .el-table__footer-wrapper tbody td {\n  color: red;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
